<div class="row mt-2">
  <div class="col-4">
    <label>Subcontractor</label>
    @if (this.tempName !== "" && this.showDepots) {
      <input type="text" readOnly [(ngModel)]='this.tempName' class='form-control'>
    }
    @if (!this.showDepots) {
      <select
        class='form-control'
        (change)='this.changeSubcontractor($event)'
        >
        <option value='select'>Select...</option>
        <option value='new'>New Subcontractor</option>
        <option value='own'>{{this.company}} Workshop/Depot</option>
        @for (item of this.subcontractors; track item) {
          <option
            [value]='item.id'
            [selected]='item.id === this.tempId'
          >{{item.name}}</option>
        }
      </select>
    }
  </div>
  @if (showDepots) {
    <div class="col-4">
      @if (this.isNewSub) {
        <label>Subcontractor Name</label>
      }
      @if (!this.isNewSub) {
        <label>Depot Name</label>
      }
      <input
        type="text"
        class='form-control'
        required
        [readOnly]='!this.editable'
        [class.is-valid]='this.workshopSubcontractor.name !== ""'
        [class.is-invalid]='this.workshopSubcontractor.name === ""'
        [(ngModel)]='this.workshopSubcontractor.name'>
    </div>
    <div class="col-4">
      <label>Contact Name</label>
      <input type="text" class='form-control' [readOnly]='!this.editable' [(ngModel)]='this.workshopSubcontractor.contact'>
    </div>
  }
</div>
@if (showDepots) {
  <div class="row">
    <div class="col-4">
      <label>Address 1</label>
      <input type="text" class='form-control' [readOnly]='!this.editable' [(ngModel)]='this.workshopSubcontractor.address1'>
    </div>
    <div class="col-4">
      <label>Address 2</label>
      <input type="text" class='form-control' [readOnly]='!this.editable' [(ngModel)]='this.workshopSubcontractor.address2'>
    </div>
    <div class="col-4">
      <label>Town / City</label>
      <input
        type="text"
        class='form-control'
        required
        [readOnly]='!this.editable'
        [class.is-valid]='this.workshopSubcontractor.city !== ""'
        [class.is-invalid]='this.workshopSubcontractor.city === ""'
        [(ngModel)]='this.workshopSubcontractor.city'>
    </div>
    <div class="col-4">
      <label>Postcode</label>
      <input
        type="text"
        class='form-control'
        required
        [readOnly]='!this.editable'
        [class.is-valid]='this.workshopSubcontractor.postcode !== ""'
        [class.is-invalid]='this.workshopSubcontractor.postcode === ""'
        [(ngModel)]='this.workshopSubcontractor.postcode'>
      <app-address-picker [postcode]='this.workshopSubcontractor.postcode' (onAddressFound)='this.foundBillingAddress($event)'></app-address-picker>
    </div>
    <div class="col-4">
      <label>Phone</label>
      <input type="text" class='form-control' [readOnly]='!this.editable' [(ngModel)]='this.workshopSubcontractor.phone'>
    </div>
    <div class="col-4">
      <label>Email</label>
      <input type="email" class='form-control' [readOnly]='!this.editable' [(ngModel)]='this.workshopSubcontractor.email'>
    </div>
    <div class="col-12">
      <label>Notes</label>
      <textarea class='form-control' [readOnly]='!this.editable' [(ngModel)]='this.workshopSubcontractor.notes'></textarea>
    </div>
  </div>
}
